import type { Dispatch, ReactNode, SetStateAction } from "react";
import type { UnsupportedRouteWarning } from "../applyExtracted";
import type { ExtractFillMap } from "../extractFill";
import type { DepartmentConfig, FormState, ManualPage } from "../types";
import type { Errors } from "../validation";
import { AdditionalServicesStep } from "./AdditionalServicesStep";
import { ContactDetailsStep } from "./ContactDetailsStep";
import { RouteOrderStep } from "./RouteOrderStep";
import { ShipmentDetailsStep } from "./ShipmentDetailsStep";

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  config: DepartmentConfig;
  errors: Errors;
  submitAttempted: boolean;
  highlighted: Set<string>;
  extractFill?: ExtractFillMap;
  unsupportedRoute: UnsupportedRouteWarning | null;
  page: ManualPage;
  onBlur: (id: string) => void;
  onBack: () => void;
  onContinue: () => void;
  backLabel?: ReactNode;
}

export function QuoteForm({
  form,
  setForm,
  config,
  errors,
  submitAttempted,
  highlighted,
  extractFill,
  unsupportedRoute,
  page,
  onBlur,
  onBack,
  onContinue,
  backLabel,
}: Props) {
  const hasErrors = submitAttempted && Object.keys(errors).length > 0;
  const shared = { form, setForm, errors, hasErrors, extractFill, onBack, onContinue };
  if (page === "route") {
    return (
      <RouteOrderStep
        {...shared}
        config={config}
        highlighted={highlighted}
        unsupportedRoute={unsupportedRoute}
        onBlur={onBlur}
        backLabel={backLabel}
      />
    );
  }
  if (page === "shipment") {
    return <ShipmentDetailsStep {...shared} config={config} highlighted={highlighted} onBlur={onBlur} />;
  }
  if (page === "services") {
    return <AdditionalServicesStep {...shared} config={config} />;
  }
  return <ContactDetailsStep {...shared} onBlur={onBlur} />;
}
